"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDummyConversationId = exports.getRealConversationId = exports.elIsOrContainedByOpenConversationsBlock = exports.elIsOrContainedByConversations = exports.correlationIdIsOnSummary = exports.correlationIdIsOnTitle = exports.toggleBodyShowAddConversationButton = exports.toggleSummaryShowAddConversationButton = exports.toggleTitleShowAddConversationButton = exports.getComputeFloatyPosition = void 0;

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _highlightHelpers = require("composer-lib/lib/helpers/highlightHelpers");

var _constants = require("composer-lib/lib/constants");

var _utils = require("composer-plugins/lib/utils");

var getComputeFloatyPosition = function getComputeFloatyPosition() {
  var extraLeftSpacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return function (_ref) {
    var contentDimensions = _ref.contentDimensions,
        targetBounds = _ref.targetBounds;
    var contentWidth = contentDimensions.width;
    var targetLeft = targetBounds.left,
        targetTop = targetBounds.top,
        targetWidth = targetBounds.width;
    var left = targetWidth + targetLeft + extraLeftSpacing;
    var maxLeft = window.innerWidth;

    if (left + contentWidth > maxLeft) {
      // attach close to left side of viewport but leave some space
      left = maxLeft - contentWidth - 20;
    }

    return {
      left: left,
      top: targetTop
    };
  };
};

exports.getComputeFloatyPosition = getComputeFloatyPosition;

function textAreaHasSelection(el) {
  if (el) {
    return el.value && el.selectionStart !== el.selectionEnd;
  }

  return false;
}

function togglePlaintextEditorShowAddConversationButton(editorBlockKey, _ref2) {
  var el = _ref2.el,
      hideAddConversationButton = _ref2.hideAddConversationButton,
      saveState = _ref2.saveState,
      showAddConversationButton = _ref2.showAddConversationButton;

  if (!saveState.readOnly && (window.getSelection().toString().length || textAreaHasSelection(el))) {
    showAddConversationButton(editorBlockKey);
  } else {
    hideAddConversationButton();
  }
}

var toggleTitleShowAddConversationButton = function toggleTitleShowAddConversationButton(props) {
  return togglePlaintextEditorShowAddConversationButton(_constants.TITLE_BLOCK_KEY, props);
};

exports.toggleTitleShowAddConversationButton = toggleTitleShowAddConversationButton;

var toggleSummaryShowAddConversationButton = function toggleSummaryShowAddConversationButton(props) {
  return togglePlaintextEditorShowAddConversationButton(_constants.SUMMARY_BLOCK_KEY, props);
};

exports.toggleSummaryShowAddConversationButton = toggleSummaryShowAddConversationButton;

var toggleBodyShowAddConversationButton = function toggleBodyShowAddConversationButton(_ref3) {
  var editorState = _ref3.editorState,
      hideAddConversationButton = _ref3.hideAddConversationButton,
      showAddConversationButton = _ref3.showAddConversationButton;
  var selection = editorState.getSelection();
  var blockKey = selection.getAnchorKey();

  if (selection.isCollapsed() || (0, _highlightHelpers.getHighlightDataFromEditorSelection)(editorState) === null) {
    hideAddConversationButton();
    return;
  }

  showAddConversationButton(blockKey);
};

exports.toggleBodyShowAddConversationButton = toggleBodyShowAddConversationButton;

var correlationIdIsOnTitle = function correlationIdIsOnTitle(index) {
  return index === (0, _draftHelpers.blockKeyToCorrelationId)(_constants.TITLE_BLOCK_KEY);
};

exports.correlationIdIsOnTitle = correlationIdIsOnTitle;

var correlationIdIsOnSummary = function correlationIdIsOnSummary(index) {
  return index === (0, _draftHelpers.blockKeyToCorrelationId)(_constants.SUMMARY_BLOCK_KEY);
};

exports.correlationIdIsOnSummary = correlationIdIsOnSummary;

var elIsOrContainedByConversations = function elIsOrContainedByConversations(target) {
  return (0, _utils.targetIsOrContainedByEl)('.conversations-wrapper', target);
};

exports.elIsOrContainedByConversations = elIsOrContainedByConversations;

var elIsOrContainedByOpenConversationsBlock = function elIsOrContainedByOpenConversationsBlock(target) {
  return (0, _utils.targetIsOrContainedByEl)('.conversations-block', target);
}; // Get the id of the real conversation object that is linked to the given dummy conversation id
// Returns the dummy id if there is no real conversation linked to the dummy


exports.elIsOrContainedByOpenConversationsBlock = elIsOrContainedByOpenConversationsBlock;

var getRealConversationId = function getRealConversationId(dummyConversations, dummyId) {
  var conversationId = dummyConversations.get(dummyId);

  if (conversationId !== null && conversationId !== undefined) {
    return conversationId;
  }

  return dummyId;
}; // Get the id of the dummy conversation that is linked to the real conversation with given id


exports.getRealConversationId = getRealConversationId;

var getDummyConversationId = function getDummyConversationId(dummyConversations, conversationId) {
  var dummyId = null;
  dummyConversations.forEach(function (real, dummy) {
    if (real === conversationId) {
      dummyId = dummy;
    }
  });
  return dummyId;
};

exports.getDummyConversationId = getDummyConversationId;